export const endpoints = {
  rewriteSentence: '/openIa/rewriteSentence/',
}
